import {
  Alert,
  Row,
  Col,
  Form,
  Label,
  CardTitle,
  ButtonGroup,
  Card,
  CardBody,
  Spinner,
  FormText,
} from "reactstrap"
import React, { useState, useEffect } from "react"
import Select from "react-select"
import LabelChargeData from "../../components/Common/labelChargeData"
import { useTranslation } from "react-i18next"

// Formik validation
import * as Yup from "yup"
import { useFormik } from "formik"
//redux
import { useSelector, useDispatch } from "react-redux"
import { getUserList, getAreas, saveAreaByUser } from "../../store/actions"
const AreaForm = props => {
  const { t } = useTranslation()
  const dispatch = useDispatch()

  const { onLoad } = props
  const [auth] = useState(JSON.parse(sessionStorage.getItem("user")))
  const [user, setUser] = useState(null)
  const [dataAreas, setDataAreas] = useState(null)
  const [errorSelect, setErrorSelect] = useState({ exist: false, msg: "" })
  const [errorSelectArea, setErrorSelectArea] = useState({
    exist: false,
    msg: "",
  })
  const { error, users, loading, loadingSelect, areas, areaByUser } = useSelector(state => {
    return {
      error: state.AreaUser.error,
      loading: state.AreaUser.loading,
      loadingSelect: state.AreaUser.loadingUser,
      users: state.AreaUser.users,
      areas: state.AreaUser.areas,
      areaByUser: state.AreaUser.areaUser,
    }
  })
  useEffect(() => {
    loadDataUser("", true)
    dispatch(getAreas())
  }, [])
  useEffect(() => {
    onLoad(user)
  }, [user])

  const loadDataUser = (inputValue, selected = false) => {
    let json = {
      filter: inputValue,
      society: process.env.REACT_APP_STYLE_TEMPLATE,
      length: 200,
    }
    if (selected || inputValue) {
      dispatch(getUserList(json))
    }
  }
  const changeClient = value => {
    setUser(value)
    validateSelect(value)
  }
  const changeArea = value => {
    setDataAreas(value)
    validateSelectArea(value)
  }
  const validateSelect = data => {
    if (data) {
      setErrorSelect({ exist: false, msg: "" })
      return true
    } else {
      setErrorSelect({ exist: true, msg: t("global:enter") + t("area:user") })
      return false
    }
  }

  const validateSelectArea = () => {
    if (dataAreas?.length > 0) {
      setErrorSelectArea({ exist: false, msg: "" })
      return true
    } else {
      setErrorSelectArea({
        exist: true,
        msg: t("global:enter") + t("area:area"),
      })
      return false
    }
  }
  const validation = useFormik({
    enableReinitialize: true,
    initialValues: {
      areas: [],
      user: "",
    },
    validationSchema: Yup.object({}),
    onSubmit: async () => {
      
      validateSelectArea()
      if (validateSelect(user) && dataAreas?.length >0) {
        await dispatch(saveAreaByUser(areaByUser, { areas: dataAreas, user: user, createdBy: auth.id.user.username }))
        setDataAreas([])
      }
    },
  })

  return (
    <Card>
      <CardBody>
        <CardTitle tag="h5" className="text-primary text-uppercase">
          <i className="mdi mdi-cog font-size-18" />
          {t("global:config")}
          <hr />
        </CardTitle>
        <div className="p-2">
          <Form
            className="form-horizontal"
            onSubmit={e => {
              e.preventDefault()
              validation.handleSubmit()
              return false
            }}
          >
            {error ? <Alert color="danger">{error}</Alert> : null}
            <div className="mb-3">
              <Label className="form-label">
                {t("area:user")}{" "}
                {loadingSelect ? <Spinner color="primary" size="sm" /> : null}
              </Label>
              <Select
                defaultValue={user}
                id="provider"
                name="provider"
                maxMenuHeight={120}
                isClearable
                options={
                  users
                    ? users.map(data => {
                      return {
                        ...data,
                        value: data.id,
                        label: data.name,
                      }
                    })
                    : []
                }
                onChange={(value, clase) => {
                  changeClient(value)
                  if (clase.action === "clear") {
                    loadDataUser("", true)
                  }
                }}
               
                onBlur={value => {
                  validateSelect(user)
                }}
              />
              {errorSelect.exist ? (
                <FormText size="xs" className="p-0 color-error">
                  {errorSelect.msg}
                </FormText>
              ) : null}
            </div>
            <div className="mb-3">
              <Label className="form-label">{t("area:area")}</Label>
              <Select
                isMulti={true}
                name="areas"
                maxMenuHeight={120}
                options={
                  areas
                    ? areas.map(data => {
                      return {
                        ...data,
                        value: data.id,
                        label: data.name,
                      }
                    })
                    : []
                }
                value={dataAreas}
                className="basic-multi-select"
                classNamePrefix="select"
                onChange={(value, clase) => {
                  changeArea(value)
                }}
                onBlur={value => {
                  validateSelectArea(value)
                }}
              />
              {  dataAreas?.length ===0 ? (
                <FormText size="xs" className="p-0 color-error">
                  {errorSelectArea.msg}
                </FormText>
              ) : null}
            </div>
            <Row>
              <Col>
                <LabelChargeData
                  label={""}
                  showloading={loading}
                  title={t("global:registerloading")}
                />
              </Col>
            </Row>
            <Row>
              <Col>
                <div className="modal-footer">
                  <ButtonGroup>
                    <button
                      className="btn btn-info save-user"
                      type="submit"
                      disabled={loading}
                    >
                      <i className=" fas fa-save me-1 " />
                      {t("global:register")}
                    </button>
                  </ButtonGroup>
                </div>
              </Col>
            </Row>
          </Form>
        </div>
      </CardBody>
    </Card>
  )
}

export default AreaForm
